import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import o from "../../../../core/ObjectPool.js";

var h = /*#__PURE__*/function () {
  function h() {
    _classCallCheck(this, h);

    this.color = [0, 0, 0, 0], this.haloColor = [0, 0, 0, 0], this.haloSize = 0, this.size = 12, this.angle = 0, this.offsetX = 0, this.offsetY = 0, this.hAnchor = 0, this.vAnchor = 0;
  }

  _createClass(h, [{
    key: "acquire",
    value: function acquire(o, _h, s, t, i, l, r, e, c) {
      this.color = o, this.haloColor = _h, this.haloSize = s, this.size = t, this.angle = i, this.offsetX = l, this.offsetY = r, this.hAnchor = e, this.vAnchor = c;
    }
  }, {
    key: "release",
    value: function release() {
      this.color[0] = this.color[1] = this.color[2] = this.color[3] = 0, this.haloColor[0] = this.haloColor[1] = this.haloColor[2] = this.haloColor[3] = 0, this.haloSize = 0, this.size = 0, this.angle = 0, this.offsetX = 0, this.offsetY = 0, this.hAnchor = 0, this.vAnchor = 0;
    }
  }]);

  return h;
}();

h.pool = new o(h);
export { h as TextProperties };